import Everest from "../media/machhapuchre.jpg"
import Rudrawati from "../media/Investments/Hydropower/Rudrawati.png"
import Rudrawati2 from "../media/Investments/Hydropower/Rudrawati2.png"
import Rudrawati3 from "../media/Investments/Hydropower/Rudrawati3.png"
import Gulangdi from "../media/Investments/Hydropower/Gulangdi.jpg"

export const projectData = [
    {
        proName: "DE MACHHAPUCHHARE PARADISE",
        topList: [
            { key: "Location", value: "16 km from Prithvi Chowk, Pokhara" },
            { key: "Land area", value: "34 Ropani" }
        ],
        tagLine: "A Unique Eco-Resort Experience",
        image: Everest,
        overview: `DE MACHHAPUCHHARE PARADISE is an upcoming eco-resort nestled in the serene hills of Pokhara, offering a unique blend of agro-tourism, adventure, and relaxation. Spread across 34 ropani of lush land, the resort is designed to provide an unforgettable experience for guests while promoting sustainable practices and community development. Just 16 km from Prithvi Chowk, the resort is easily accessible yet feels like a world away from the hustle and bustle of city life.
We’re not just building a resort — we’re building a sustainable community. From the architecture to employment, we believe in giving back.
We’ve created spaces that not only blend into the natural environment but also awaken your senses. At DE MACHHAPUCHHARE PARADISE, you don’t just stay — you live the moment.
`,
    features: {
      "Accommodation Options": [
        {
          key: "Mountain View Cottages",
          value:
            "Spacious cottages with private balconies offering panoramic views of the Himalayas. Each cottage is designed to provide comfort and luxury, ensuring a memorable stay.",
        },
        {
          key: "Village-Style Eco-Huts",
          value:
            "Traditional Nepali-style huts made from sustainable materials, blending seamlessly with the natural environment. These eco-huts offer a unique cultural experience.",
        },
        {
          key: "Treehouses",
          value:
            "Hidden among the trees, these treehouses provide an intimate connection with nature, perfect for nature lovers seeking a unique experience.",
        },
        {
          key: "Luxury Glamping Tents",
          value:
            "Rustic yet comfortable, these glamping tents offer a blend of outdoor adventure and modern amenities, ensuring a luxurious camping experience.",
        },
        {
          key: "Campgrounds",
          value:
            "Ideal for those who prefer the open sky and bonfires, our campgrounds provide a more rustic experience with basic facilities.",
        },
      ],
      "Agro-Tourism Experience": [
        {
          key: "Organic Farm",
          value:
            "At the heart of the resort lies a vibrant, working organic farm. Guests can participate in seasonal farming activities, learn from local farmers, and experience the rhythm of the land.",
        },
        {
          key: "Cultural Demos",
          value:
            "Discover the charm of village life through cultural demonstrations and folk stories. Join us during rice planting and harvesting festivals for a deeper immersion into local traditions.",
        },
        {
          key: "Farm-to-Fork Dining",
          value:
            "Enjoy authentic, locally-sourced meals prepared by our farm chefs. Dine on fresh produce straight from our organic farm, ensuring a truly unique culinary experience.",
        },
      ],
      "Adventure Activities": [
        {
          key: "Zip-lining",
          value:
            "Soar above the forest with Machhapuchhare as your backdrop, experiencing the thrill of zip-lining in a breathtaking setting.",
        },
        {
          key: "Rock Climbing & Rappelling",
          value:
            "Challenge yourself on natural rock formations, with experienced guides ensuring your safety and enjoyment.",
        },
        {
          key: "Horseback Riding",
          value:
            "Ride along scenic rural paths, enjoying the beauty of the surrounding landscapes.",
        },
        {
          key: "Nature Walks & Bird Watching",
          value:
            "Discover hidden trails and observe local wildlife with expert guides, making every step an adventure.",
        },
        {
          key: "Yoga & Meditation",
          value:
            "Recharge your soul with serene yoga decks and meditation spaces, offering a peaceful retreat for mindfulness and relaxation.",
        },
      ],
      "Sustainability & Community": [
        {
          key: "Eco-Conscious Design",
          value:
            "The resort is designed with sustainability in mind, featuring zero-plastic policies and the use of sustainable building materials.",
        },
        {
          key: "Solar & Rainwater Systems",
          value:
            "Harnessing renewable energy and conserving water, the resort is committed to minimizing its environmental footprint.",
        },
        {
          key: "Local Employment",
          value:
            "Creating job opportunities for the local community, supporting economic development and social well-being.",
        },
        {
          key: "Cultural Preservation",
          value:
            "Workshops and festivals are organized to preserve and promote local heritage, ensuring the cultural richness of the region is maintained.",
        },
      ],
    },
    investment: {
      "Strategic Location": [
        {
          key: "Proximity to Pokhara",
          value:
            "Just 16 km from Prithvi Chowk, the resort offers easy accessibility while maintaining a serene and secluded environment.",
        },
        {
          key: "Tourist Destination",
          value:
            "Capitalize on the growing tourism industry in Pokhara, a major tourist hub in Nepal.",
        },
      ],
      "Market Potential": [
        {
          key: "Growing Demand",
          value:
            "Increasing interest in eco-tourism and adventure travel, with a growing number of travelers seeking sustainable and unique experiences.",
        },
        {
          key: "Dual Revenue Streams",
          value:
            "Revenue from accommodation, activities, dining, and potential eco-tourism initiatives, ensuring a diversified income.",
        },
      ],
      "Community Support": [
        {
          key: "Local Partnerships",
          value:
            "Strong relationships with local communities and authorities, ensuring smooth operations and community support.",
        },
        {
          key: "Sustainable Practices",
          value:
            "Commitment to environmental and social sustainability, enhancing the resort’s appeal to eco-conscious travelers.",
        },
        {
          key: "Funding Options",
          value:
            "Equity investment, debt financing, and government incentives available to support your investment.",
        },
      ],
    },
    whyUs: [
      {
        key: "Unique Experience",
        value:
          "Offer guests a blend of adventure, relaxation, and cultural immersion, creating unforgettable memories.",
      },
      {
        key: "Growing Market",
        value:
          "Capitalize on the rising trend of eco-tourism and sustainable travel, tapping into a growing market segment.",
      },
      {
        key: "Strategic Location",
        value:
          "Benefit from the high tourist traffic in Pokhara, ensuring a steady flow of visitors.",
      },
      {
        key: "Community Impact",
        value:
          "Support local development and environmental sustainability, contributing to the region’s socio-economic growth.",
      },
      {
        key: "High Returns",
        value:
          "Attractive financial projections with a strong potential for growth and high returns on investment.",
      },
    ],
  
        contact: [
            { key: "Email", value: "info@demachhapuchhareparadise.com" },
            { key: "Phone", value: "+977-9851410058" }
        ]
    },
    {
        proName: "Gulangdi Small Hydropower Project",
        tagLine: "A Sustainable Investment Opportunity",
        topList: [
            { key: "Location", value: "Gulmi District, Nepal" },
            { key: "Capacity", value: "980 KW" }
        ],
        image: Gulangdi,
        overview:
            "The Gulangdi Small Hydropower Project is a state-of-the-art renewable energy initiative designed to harness the region’s abundant water resources. Strategically located in the picturesque Gulmi District, this project offers a unique blend of modern technology and sustainable practices, making it an attractive investment opportunity. Brahma Jyoti Holdings Limited (BJHL), a prominent public Holdings company, has secured over 85% of the project's total equity. This substantial financial commitment underscores BJHL's dedication to advancing Nepal's energy infrastructure. The project is currently under construction and is expected to be completed within the next 15 months, marking a significant milestone in the region's energy development.",
        projectDetails: [
            { key: "River Source", value: "The project utilizes the waters of the Gulangdi River, a tributary of the West Seti River, known for its consistent flow and potential for hydroelectric generation." },
            { key: "Technology", value: "The project employs modern, efficient turbines and generators to maximize energy production while minimizing environmental impact." },
            { key: "Infrastructure", value: "The project includes a small dam, a diversion channel, and a powerhouse equipped with advanced technology." },
            { key: "Capacity", value: "980 kW, capable of generating a significant amount of clean, renewable energy." },
            { key: "Environmental Impact", value: "A clean energy source that contributes to reducing carbon emissions and promoting sustainable development." },
            { key: "Market Potential", value: "High demand for electricity in the region, with potential for sales to the national grid." },
            { key: "Community Benefits", value: "Supports local economic development and job creation, enhancing the region’s socio-economic landscape." }
        ],
        features: [
            { key: "Strategic Location", value: "Positioned in a region with significant water resources and growing energy demands." },
            { key: "Modern Facilities", value: "Designed with durability and efficiency in mind, ensuring long-term sustainability." },
            {
                key: "Revenue Streams",
                value: [
                    "Electricity sales to the national grid.",
                    "Potential for additional revenue through eco-tourism and community engagement initiatives."
                ]
            },
            { key: "Community Support", value: "Strong local support and partnerships for sustainable development." }
        ],
        investment: [
            { key: "Renewable Energy", value: "Contribute to a sustainable future with a clean energy project." },
            { key: "High Demand", value: "Capitalize on the growing need for reliable electricity in the region." },
            { key: "Community Impact", value: "Support local development and job creation." },
            { key: "Long-Term Returns", value: "Benefit from a stable and growing energy market." },
            { key: "Funding Options", value: "Various funding options are available, including equity investment, debt financing, and government incentives." }
        ],
        environmentalImpact: [
            { key: "Sustainable Practices", value: "The project adheres to strict environmental standards, ensuring minimal impact on local ecosystems." },
            { key: "Community Engagement", value: "The project includes initiatives to support local communities, such as job creation, skill development, and community infrastructure projects." },
            { key: "Climate Change Mitigation", value: "By generating clean energy, the project helps reduce carbon emissions and supports global efforts to combat climate change." }
        ],
        whyUs: [
            { key: "Renewable Energy", value: "Contribute to a sustainable future with a clean energy project." },
            { key: "High Demand", value: "Capitalize on the growing need for reliable electricity in the region." },
            { key: "Community Impact", value: "Support local development and job creation." },
            { key: "Long-Term Returns", value: "Benefit from a stable and growing energy market." },
            { key: "Strategic Location", value: "Positioned in a region with significant water resources and growing energy demands." }
        ]
    },
    {
        proName: "Rudrawati Badigad Hydropower Project",
        tagLine: "A Strategic Investment in Nepal's Renewable Energy",
        topList: [
            { key: "Location", value: "Baglung District, Nepal" },
            { key: "Capacity", value: "9.4 MW" }
        ],
        image: Rudrawati,
        overview: `The Rudrawati Badigad Hydropower Project is a strategically located run-of-river hydroelectric project in Baglung, Nepal. The project is designed to harness the natural flow of the Rudrawati and Badigad rivers to generate renewable energy efficiently, with minimal environmental and social impacts. By leveraging the consistent water flow of these rivers, the project aims to contribute to Nepal's growing demand for clean energy while ensuring long-term sustainability.

The generated electricity will be transmitted to the national grid, with a connection point located approximately 900 meters from the powerhouse. This proximity ensures low transmission losses, enhancing overall project efficiency and reliability. The project design follows established best practices in hydropower development, focusing on technical efficiency, environmental responsibility, and economic viability.`,
        projectDetails: [
            { key: "River Source", value: "The project utilizes the waters of the Rudrawati Badigad River, known for its consistent flow and potential for hydroelectric generation." },
            { key: "Technology", value: "The project employs modern, efficient turbines and generators to maximize energy production." },
            { key: "Infrastructure", value: "The project includes dam, diversion channel, and a powerhouse equipped with advanced technology." },
            { key: "Capacity", value: "9.4 MW, capable of generating a significant amount of clean, renewable energy." },
            { key: "Operational Efficiency", value: "The short distance to the national grid ensures minimal transmission losses, improving the overall efficiency of power delivery. The project's design incorporates proven hydropower technologies that optimize energy generation and minimize downtime, ensuring reliable and continuous electricity supply." }
        ],
        features: [
            { key: "Strategic Importance", value: "The project aligns closely with Nepal's national priorities for renewable energy and energy security. By providing clean, renewable electricity to the national grid, the project contributes to reducing Nepal's dependence on imported fossil fuels and enhances overall energy security." },
            { key: "Sustainable Development", value: "The project promotes environmentally responsible energy production with minimal ecological impact, supporting Nepal's transition to a low-carbon economy." },
            { key: "Economic Growth", value: "Beyond energy generation, the project will create local employment opportunities during construction and operational phases, stimulating regional economic development. Local procurement and engagement initiatives will support small businesses and community enterprises in the Baglung area." },
            { key: "Project Viability", value: "The Rudrawati Badigad Hydropower Project benefits from a well-established run-of-river design and a short, efficient grid connection. These factors significantly reduce technical and operational risks, enhancing project feasibility." },
            { key: "Long-term Revenue Potential", value: "The project's revenue model is supported by Nepal's favorable hydropower policies, tariff structures, and government incentives. Long-term power purchase agreements (PPAs) with the national utility provide predictable cash flows and stable returns for investors." }
        ],
        investment: [
            { key: "Renewable Energy", value: "Contribute to a sustainable future with a clean energy project." },
            { key: "Community Impact", value: "Support local development and job creation." },
            { key: "Long-Term Returns", value: "Benefit from a stable and growing energy market." },
            { key: "Strategic Location", value: "Positioned in a region with significant water resources and growing energy demands." }
        ],
        environmentalImpact: [
            { key: "Run-of-River Design", value: "The run-of-river approach minimizes water storage and ecological disruption, ensuring environmental sustainability." },
            { key: "Carbon Reduction", value: "By generating clean energy, the project helps reduce carbon emissions and supports global efforts to combat climate change." },
            { key: "Community Support", value: "The project includes initiatives to support local communities, ensuring equitable benefit distribution and sustainable development." }
        ],
        gallery: [
            Rudrawati2,
            Rudrawati3
        ],
        whyUs: [
            { key: "Renewable Energy", value: "Contribute to a sustainable future with a clean energy project." },
            { key: "Community Impact", value: "Support local development and job creation." },
            { key: "Long-Term Returns", value: "Benefit from a stable and growing energy market." },
            { key: "Strategic Location", value: "Positioned in a region with significant water resources and growing energy demands." },
            { key: "Strong Technical Feasibility", value: "Well-established run-of-river design with strategic alignment to Nepal's renewable energy objectives." }
        ]
    }
];